import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchAssociationList = createAsyncThunk(
  "fetchAssociationList",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/associations`
    );
    return result;
  }
);

export const deleteAssociationList = createAsyncThunk(
  "deleteAssociationList",
  async ({ providerId, deleteDisplayID }) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/providers/${providerId}/associations/${deleteDisplayID}`
    );
    return result;
  }
);

export const fetchAssociateSuggestion = createAsyncThunk(
  "fetchAssociateSuggestion",
  async (search) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/associations?query=${search}&view=search`
    );
    return result;
  }
);

export const updateAssociationList = createAsyncThunk(
  "UpdateAssociationList",
  async ({ providerId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/associations`,
      data
    );
    return result;
  }
);
